/**
 * Version der Spielregeln.
 *
 * Jede Partie merkt sich, nach welchen Regeln sie begonnen wurde (`S.ver`, im Zugprotokoll als
 * zweites Argument von `newGame`, im Mehrspieler in `matches.ver`). Partien ohne Angabe sind Version 1.
 *
 * So ändert man Spielregeln, ohne laufende Partien, Bestenliste oder Mehrspieler zu gefährden:
 *   1. RULES um eins erhöhen.
 *   2. Jede neue oder geänderte Regel hinter `since(RULES)` stellen, z. B.
 *        if (since(2)) { …neue Regel… } else { …alte Regel… }
 *      Das gilt auch für neue Inhalte, die gezogen werden (Probleme, Krisen, Entscheidungen), weil sie
 *      den Zufall verschieben.
 *   3. Den Test `tests/rules-v1.test.ts` grün halten: Er spielt gespeicherte Partien aus Version 1 nach
 *      und prüft, dass sie exakt gleich ausgehen.
 *   4. Nach dem Build die Edge Function `verify-run` neu deployen (sie enthält die Engine).
 */
import { S } from './state';

/** Aktuelle Regelversion. Neue Partien starten mit dieser Version. */
export const RULES = 2;

/** Was sich mit jeder Regelversion ändert (für den Hinweis beim Umstieg). */
export const RULE_NOTES: Record<number, string[]> = {
  2: [
    'Zu jedem Meinungsthema lassen sich Gesetze anstoßen, auch ohne passendes Problem auf der Liste.',
    'Gesetze, die zur Stimmung im Land passen, bringen beim Inkrafttreten Zustimmung, Gesetze gegen die Mehrheit kosten welche.',
    'Teure Gesetze lassen sich im Entwurf gegenfinanzieren.',
  ],
};

/** Regelversion eines Spielstands (fehlend = 1). */
export const verOf = (s: { ver?: number } | null | undefined): number => (s && Number.isInteger(s.ver) && (s.ver as number) > 0 ? (s.ver as number) : 1);

/** Gilt in der laufenden Partie eine Regel, die mit Version `v` eingeführt wurde? */
export const since = (v: number): boolean => verOf(S) >= v;

/** Stammt der Spielstand aus einer neueren Version, als dieser Code kennt? Dann muss die Seite neu geladen werden. */
export const tooNew = (s: { ver?: number } | null | undefined): boolean => verOf(s) > RULES;
